import { Log } from 'ng2-logger';
import React, { Component, Dispatch } from 'react';
import { connect } from 'react-redux';
import Paginate from '../../../../../components/table/paginate';
import Announce from '../../../../../components/templates/announce';
import Translator from '../../../../../core/i18n';
import { IAction, IAppState } from '../../../../../models/action/core';
import * as Actions from '../../../../../store/actions/examSession';
import { IPagedQueryS } from '../../../../../models/components/paginate';
import { IFilterExamStudents, IStudents } from '../../../../../models/components/add-exam-sessions';
import { Notification } from '../../../../../components/notification/main';
import Tooltip from '../../../../../components/tooltip/main';
import { Button } from '../../../../../components/ui-elements/main';

const T = Translator.create();
const _logger = Log.create('Add Session Students');

interface IStudentsModalProps {
    currentTab: string;
    coursePageActivityId?: string;
    coursePageClassId?: string;
    examId?: string;
    examSessionId: string;
    dispatch?: any;
    studentDatas?: {
        filters: IPagedQueryS;
        results: IStudents[] | null;
    };
    publishDatas?: any;
}

interface IStudentsModalState {
    filters: IPagedQueryS;
    isAll: boolean;
    disAllowedStudentIds: string[];
    selectedStudentIds: string[];
    searchedText: string;
}

export class Students extends Component<IStudentsModalProps, IStudentsModalState> {
    constructor(props: any) {
        super(props);

        this.state = {
            filters: {
                page: 1,
                take: 50,
                total: 0
            },
            isAll: false,
            disAllowedStudentIds: [],
            selectedStudentIds: [],
            searchedText: ''
        };
    }

    componentDidMount = async () => {
        await this.getStudent();
    };

    getStudent = async () => {
        if (this.props.examSessionId && this.props.examId) {
            const filters: IFilterExamStudents = {
                examSessionId: this.props.examSessionId,
                examId: this.props.examId,
                searchedText: this.state.searchedText
            };
            this.props.dispatch(Actions.ExamSessionStudentList(filters, this.state.filters, '', 'get'));
        }
    };

    onPageChange = async (page: number) => {
        this.state.filters.page = page;
        this.setState(this.state);
        await this.getStudent();
    };

    selectAll = async (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event && event.target) {
            this.setState({ isAll: event.target.checked });
            if (!event.target.checked) {
                this.setState({ disAllowedStudentIds: [] });
            }
        }
    };

    onSelectStudent = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event && event.target) {
            if (!this.state.isAll) {
                const selectedIds = Object.assign([], this.state.selectedStudentIds);
                const id: string = event.currentTarget.dataset.id || '';
                if (event.target.checked && id) {
                    selectedIds.push(id);
                } else if (!event.target.checked && id) {
                    const index = selectedIds.indexOf(id);
                    if (index !== -1) {
                        selectedIds.splice(index, 1);
                    }
                }
                this.setState({ selectedStudentIds: selectedIds });
            } else {
                const disAllowedIds = Object.assign([], this.state.disAllowedStudentIds);
                const id: string = event.currentTarget.dataset.id || '';
                if (!event.target.checked && id) {
                    disAllowedIds.push(id);
                } else if (event.target.checked && id) {
                    const index = disAllowedIds.indexOf(id);
                    if (index !== -1) {
                        disAllowedIds.splice(index, 1);
                    }
                }
                this.setState({ disAllowedStudentIds: disAllowedIds });
            }
        }
    };

    deleteSelectedStudents = () => {
        if (
            this.props.publishDatas!.activeStatus === 0 &&
            this.props.publishDatas!.isPassive === 1
        ) {
            if (
                this.props.examSessionId &&
                this.props.examId &&
                ((this.state.selectedStudentIds && this.state.selectedStudentIds.length) || this.state.isAll)
            ) {
                this.props.dispatch(
                    Actions.ExamSessionDeleteStudent(
                        this.state.isAll,
                        this.props.examSessionId,
                        this.props.examId,
                        this.state.selectedStudentIds,
                        this.state.searchedText,
                        this.deleteSelectedStudentsCallBack,
                        this.state.disAllowedStudentIds,
                        '',
                        'get'
                    )
                );
            }
        } else {
            Notification.setNotification('error', T.t('r_activity_exam_session_edit_error').replace('{0}', T.t('r_activity_exam_session_edit_error_students')), 'topRight');
        }
    };

    deleteSelectedStudentsCallBack = async () => {
        await this.getStudent().then(() => {
            this.setState({
                selectedStudentIds: [],
                disAllowedStudentIds: [],
                isAll: false
            });
            this.props.dispatch(Actions.ExamSessionAddStudentListDefault('', 'get'));
            if (this.props.coursePageActivityId && this.props.coursePageClassId && this.props.examId && this.props.examSessionId) {
                this.props.dispatch(
                    Actions.ExamSessionListGetAction(
                        this.props.examId,
                        this.props.coursePageActivityId,
                        this.props.coursePageClassId,
                        '',
                        'get',
                        this.props.examSessionId
                    )
                );
                this.props.dispatch(Actions.ExamSessionPublishDatas(this.props.examId, this.props.examSessionId, '', 'get'));
            }
        });
    };

    inputOnChange = async (e: any) => {
        if (e && e.target) {
            await this.inputOnChangeSetState(e.target.value);
            await this.getStudent();
        }
    };

    inputOnChangeSetState = async (value: string) => {
        const filters = this.state.filters;
        filters.page = 1;
        this.setState({
            selectedStudentIds: [],
            disAllowedStudentIds: [],
            isAll: false,
            searchedText: value,
            filters
        });
    };

    deleteAllStudents = () => {
        if (
            this.props.publishDatas!.activeStatus === 0 &&
            this.props.publishDatas!.isPassive === 1
        ) {
            if (this.props.examSessionId && this.props.examId) {
                this.props.dispatch(
                    Actions.ExamSessionDeleteStudent(
                        true,
                        this.props.examSessionId,
                        this.props.examId,
                        [],
                        '',
                        this.deleteSelectedStudentsCallBack,
                        [],
                        '',
                        'get'
                    )
                );
            }
        } else {
            Notification.setNotification('error', T.t('r_activity_exam_session_edit_error').replace('{0}', T.t('r_activity_exam_session_edit_error_students')), 'topRight');
        }
    };

    public render() {
        return (
            <div
                className={'tab-pane fade' + (this.props.currentTab === '_sessionStudents' ? ' show active' : '')}
                style={{ width: '100%' }}
                role="tabpanel"
                aria-labelledby="all-users-tab"
            >
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-12">
                            <div className="row mt-3 align-items-end">
                                <div className="col-md-5 col-12" style={{ paddingLeft: '0.5rem', paddingRight: '0.5rem' }}>
                                    <div className="k365-input date-picker">
                                        <label className='input-label'>{T.t('r_gen_exam_session_search_student')}</label>
                                        <input placeholder={T.t('r_gen_exam_session_search_student')} type="text" onChange={this.inputOnChange} />
                                        <div className="search icon">
                                            <svg
                                                width="15px"
                                                height="17px"
                                                viewBox="0 0 15 17"
                                                version="1.1"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <g
                                                    id="Symbols"
                                                    stroke="none"
                                                    strokeWidth="1"
                                                    fill="none"
                                                    fillRule="evenodd"
                                                    opacity="0.800000012"
                                                >
                                                    <g
                                                        id="Main-Navigaiton"
                                                        transform="translate(-1048.000000, -24.000000)"
                                                        fill="#979694"
                                                        fillRule="nonzero"
                                                    >
                                                        <g id="Right-Menu" transform="translate(1039.000000, 14.000000)">
                                                            <g id="icon/magnifier" transform="translate(0.000000, 2.000000)">
                                                                <path
                                                                    d="M20.2929508,18.8906861 L23.7893522,23.3860594 L22.2106478,24.6139406 L18.7316754,20.1409761 C17.7797647,20.6874961 16.6763769,21 15.5,21 C11.9101491,21 9,18.0898509 9,14.5 C9,10.9101491 11.9101491,8 15.5,8 C19.0898509,8 22,10.9101491 22,14.5 C22,16.1925933 21.3530546,17.7340844 20.2929508,18.8906861 Z M15.5,20 C18.5375661,20 21,17.5375661 21,14.5 C21,11.4624339 18.5375661,9 15.5,9 C12.4624339,9 10,11.4624339 10,14.5 C10,17.5375661 12.4624339,20 15.5,20 Z"
                                                                    id="Combined-Shape"
                                                                />
                                                            </g>
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 col-6 mt-2" style={{ padding: '0 0.5rem' }}>
                                    {this.props.studentDatas &&
                                    this.props.studentDatas.results &&
                                    this.props.studentDatas.results.length > 0 &&
                                    ((this.state.selectedStudentIds && this.state.selectedStudentIds.length) || this.state.isAll) ? (

                                        <Button
                                            button_type='secondary'
                                            size='medium'
                                            style={{maxWidth: 'fit-content', float:'inline-end'}}
                                            onClick={this.deleteSelectedStudents}
                                            text={T.t('r_gen_exam_session_delete_student')}
                                            iconPosition='left'
                                            materialicon='delete'
                                        />
                                    ) : (

                                        <Button
                                            button_type='secondary'
                                            size='medium'
                                            style={{maxWidth: 'fit-content', float:'inline-end'}}
                                            onClick={this.deleteSelectedStudents}
                                            text={T.t('r_gen_exam_session_delete_student')}
                                            iconPosition='left'
                                            materialicon='delete'
                                        />
                                    )}
                                </div>
                                <div className=" col-md-3 col-6 mt-2" style={{ padding: ' 0 0.5rem' }}>
                                    <Button
                                        button_type='secondary'
                                        size='medium'
                                        style={{width: '100%', float:'inline-end'}}
                                        onClick={this.deleteAllStudents}
                                        text={T.t('r_gen_exam_session_delete_all_student')}
                                        iconPosition='left'
                                        materialicon='delete'/>
                                </div>
                            </div>

                            <div className="row mt-3 px-2">
                                <div className="row d-flex justify-content-between w-100 my-2">
                                    <div className="col">
                                        <div className="title ">
                                            <span className="oturum-title">{T.t('r_gen_exam_session_student_list')}</span>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="title"  style={{float: 'inline-end'}}>
                                            <span className="d-flex align-items-center">
                                                {T.t('r_gen_exam_session_selected_students')} :{' '}
                                                {this.state.isAll
                                                    ? this.props.studentDatas && this.props.studentDatas.filters
                                                        ? this.props.studentDatas.filters.total! - this.state.disAllowedStudentIds.length
                                                        : 0
                                                    : this.state.selectedStudentIds.length}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="question-list w-100">
                                    <div className="no-hover question-row w-100">
                                        <div className="w-10 ">
                                            {this.props.studentDatas &&
                                            this.props.studentDatas.results &&
                                            this.props.studentDatas.results.length > 0 ? (
                                                <span className="tick-radio position-relative d-inline-block">
                                                    <input
                                                        onChange={this.selectAll}
                                                        type="checkbox"
                                                        checked={this.state.isAll && this.state.disAllowedStudentIds.length === 0}
                                                        name="demo"
                                                        defaultValue="one"
                                                        id="radio-three"
                                                        className="form-radio"
                                                    />
                                                </span>
                                            ) : (
                                                <span className="tick-radio position-relative d-inline-block">
                                                    <input
                                                        type="checkbox"
                                                        name="demo"
                                                        defaultValue="one"
                                                        id="radio-three"
                                                        className="form-radio"
                                                    />
                                                </span>
                                            )}
                                        </div>
                                        <div className="w-30 font-weight-bold">
                                            <span>{T.t('r_firstname')}</span>
                                        </div>
                                        <div className="w-30 font-weight-bold">
                                            <span>{T.t('r_lastname')}</span>
                                        </div>
                                        <div className="w-30 font-weight-bold">
                                            <span>{T.t('r_username')}</span>
                                        </div>
                                        <a className="bg-transparent row_delete_btn">
                                            <i className="material-icons" />
                                        </a>
                                    </div>

                                    {this.props.studentDatas &&
                                    this.props.studentDatas.results &&
                                    this.props.studentDatas.results.length ? (
                                        this.props.studentDatas.results.map((item: IStudents) => {
                                            return (
                                                <div
                                                    className="question-row w-100"
                                                    style={{ overflow: 'visible  !important' }}
                                                    key={item.userId}
                                                >
                                                    <div className="w-10 ">
                                                        <span className="tick-radio position-relative d-inline-block">
                                                            {item.alreadyUsed ? (
                                                                <>
                                                                    <Tooltip data={T.t('r_gen_exam_session_student_already_used')} position='top'>
                                                                        <i
                                                                            className="material-icons mr-2"
                                                                            style={{ width: 20, height: 20, fontSize: 20 }}
                                                                        >
                                                                            info
                                                                        </i>

                                                                    </Tooltip>

                                                                    <input className="form-radio" style={{ display: 'none' }} />
                                                                </>
                                                            ) : (
                                                                <input
                                                                    data-id={item.userId}
                                                                    onChange={this.onSelectStudent}
                                                                    type="checkbox"
                                                                    name="demo"
                                                                    defaultValue="one"
                                                                    id="radio-three"
                                                                    checked={
                                                                        (!this.state.isAll &&
                                                                            this.state.selectedStudentIds.includes(item.userId)) ||
                                                                        (this.state.isAll &&
                                                                            !this.state.disAllowedStudentIds.includes(item.userId))
                                                                    }
                                                                    className="form-radio mr-2"
                                                                />
                                                            )}
                                                        </span>
                                                    </div>
                                                    <div className="w-30 d-flex align-items-center">
                                                        <label className="text-truncate text-dark  mb-0">{item.firstName}</label>
                                                    </div>
                                                    <div className="w-30 d-flex align-items-center">
                                                        {' '}
                                                        <label className="text-truncate text-dark mb-0">{item.lastName}</label>{' '}
                                                    </div>
                                                    <div className="w-30 d-flex align-items-center">
                                                        {' '}
                                                        <label className="text-truncate text-dark mb-0">{item.userName}</label>{' '}
                                                    </div>
                                                    <a onClick={this.deleteSelectedStudents} className="row_delete_btn">
                                                        <i className="material-icons">close</i>
                                                    </a>
                                                </div>
                                            );
                                        })
                                    ) : (
                                        <div className="d-flex justify-content-center flex-column align-items-center">
                                            <Announce />
                                            <span className="mt-4 font-weight-bolder">{T.t('r_gen_no_assigned_student')}</span>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {this.props.studentDatas && this.props.studentDatas.results && this.props.studentDatas.results.length > 0 && (
                                <div className="row-options justify-content-end">
                                    <div
                                        className="page-sorting d-flex align-items-center justify-content-center"
                                        style={{ marginTop: '5px' }}
                                    />
                                    <Paginate
                                        class={'custom-paginate'}
                                        filters={this.props.studentDatas.filters}
                                        onPageChange={this.onPageChange}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IStudentsModalProps): IStudentsModalProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IStudentsModalProps = Object.assign({}, ownProps, {
        coursePageClassId: state.coursePage.coursePageClassId,
        coursePageActivityId: state.coursePage.coursePageActivityId,
        studentDatas: state.examSession.studentDatas,
        publishDatas: state.examSession.publishDatas
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    return (
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId &&
        next.examSession.studentDatas === prev.examSession.studentDatas &&
        next.examSession.publishDatas === prev.examSession.publishDatas
    );
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CStudents = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(Students);

export default CStudents;
